import {
  Box,
  Flex,
  Image,
  Text,
  chakra,
  shouldForwardProp,
} from "@chakra-ui/react";
import React, { useMemo } from "react";
import { NavLink, useLocation, useSearchParams } from "react-router-dom";
import { AnimatePresence, isValidMotionProp, motion } from "framer-motion";
import { useSelector } from "react-redux";
import useDeviceType from "../../hook/useDeviceType";
import { COMMON_WEB_PATH } from "../../constant";
import { useTranslation } from "react-i18next";
import useHotType from "../../hook/useHotType";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

const ignorePath = [
  "slots",
  "live-casino",
  "bingo",
  "fish",
  "table",
  "block-chain",
  "gamebox",
];

const MenuMachine = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const deviceType = useDeviceType();

  const [searchParams] = useSearchParams();

  const searchParamsType = searchParams.get("type") || "Popular";

  const location = useLocation();

  const { hotType } = useHotType();

  const includePath = ignorePath.some((path) =>
    location.pathname.includes(path)
  );

  const isGameBox = useMemo(() => {
    return location.pathname.includes("gamebox");
  }, [location.pathname]);

  const animationProps = useMemo(() => {
    if (deviceType) {
      return deviceType === "PC"
        ? {
            initial: { x: "0%" },
            animate: { x: "0%" },
            exit: { x: "0%" },
            transition: { duration: 0.15, ease: "easeInOut" },
          }
        : {
            initial: { x: "-100%" },
            animate: { x: "0%" },
            exit: { x: "-100%" },
            transition: { duration: 0.15, ease: "easeInOut" },
          };
    }
  }, [deviceType]);

  const isStickyLeft = useSelector((state) => state.isStickyLeft);

  return isGameBox && deviceType === "pc" ? null : !includePath ? (
    <AnimatePresence>
      <Box
        maxW={`325px`}
        w={{
          base: "0px",
          xl: "100%",
        }}
        overflowX={`hidden`}
        bgSize="cover"
        bgPos="center"
        bgRepeat={`no-repeat`}
        // className="wrapper-menu-shadow"
        position="relative"
        {...(deviceType === "PC"
          ? {
              position: "fixed",
              left: "0px",
              w: "325px",
              h: "100dvh",
            }
          : {})}
        zIndex={1000}
        pt={{
          base: "0px",
          sm: "0px",
        }}
      >
        <ChakraBox
          h={`100%`}
          position={isStickyLeft ? "fixed" : "relative"}
          left="0px"
          pb={{ base: "0px" }}
          {...animationProps}
        >
          <Flex
            w={{
              base: "285px",
              md: "100%",
              lg: "100%",
            }}
            h={"calc(100% - 0px)"}
            bg="transparent"
            direction={`column`}
            alignItems={`flex-start`}
            gap={{
              base: "10px",
              lg: "25px",
            }}
            pb="20px"
            // mt="20px"
            onClick={(event) => {
              event.stopPropagation();
            }}
            overflowY="scroll"
            overflowX="hidden"
            className="no-scrollbar"
            position="fixed"
            bgImage={`${COMMON_WEB_PATH}/theOne/header/menu_left_bg.png`}
            bgPos="center"
            bgSize="100% 100%"
          >
            <Flex w="50%" direction={`column`} gap="0px">
              {hotType?.map((item) => {
                return (
                  <Flex
                    as={NavLink}
                    to={{
                      search: `?type=${item.hash}`,
                    }}
                    cursor={"pointer"}
                    justifyContent={"center"}
                    align={"center"}
                    gap="5px"
                    h="150px"
                    w="100%"
                    position="relative"
                    direction={"column"}
                    _hover={{
                      _before: {
                        content: "''",
                        position: "absolute",
                        w: "100%",
                        h: "100%",
                        left: "0px",
                        top: "0px",
                        bgImage: `${COMMON_WEB_PATH}/theOne/header/menu_active_light.png`,
                        bgSize: "90% 120%",
                        bgRepeat: "no-repeat",
                        backgroundPositionY: "-20px",
                      },
                    }}
                    _before={{
                      content: "''",
                      position: "absolute",
                      bottom: "0",
                      left: "0",
                      w: "100%",
                      h: "5px",
                      bgImage: `${COMMON_WEB_PATH}/theOne/header/menu_border.png`,
                      bgSize: "100% 100%",
                    }}
                    _after={{
                      content: "''",
                      position: "absolute",
                      w: "100%",
                      h: "100%",
                      left: "0px",
                      top: "0px",
                      bgImage: `${COMMON_WEB_PATH}/theOne/header/menu_active_light.png`,
                      bgSize: "90% 120%",
                      bgRepeat: "no-repeat",
                      backgroundPositionY: "-20px",
                      display:
                        searchParamsType === item.hash ? "block" : "none",
                    }}
                  >
                    <Image
                      src={`${COMMON_WEB_PATH}/theOne/header/${item.type}_icon.png`}
                    />
                    <Text
                      fontWeight={"bold"}
                      fontSize="24px"
                      textShadow={"0 0 1.5px white"}
                    >
                      {i18n(item.label)}
                    </Text>
                  </Flex>
                );
              })}
            </Flex>
          </Flex>
        </ChakraBox>
      </Box>
    </AnimatePresence>
  ) : null;
};

export default MenuMachine;
